/* eslint-disable import/no-cycle */
import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const getSearchListUsersSA = async (searchText?: string) => {
  const dataAPI = await HttpService.post(
    ApiService.masterUser.getSearchListUsersSA,
    JSON.stringify({
      SearchText: searchText,
    })
  );

  return dataAPI.data.data;
};

export const editSingleUserSA = async (
  binusianID?: string,
  roleName?: string,
  userUp?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.masterUser.editSingleUserSA,
    JSON.stringify({
      BinusianID: binusianID,
      RoleName: roleName,
      UserUp: userUp,
    })
  );

  return dataAPI.data.data;
};

export const getRoleNameProfileSA = async (binusianID?: string) => {
  const dataAPI = await HttpService.post(
    ApiService.profileUser.getRoleNameProfileSA,
    JSON.stringify({
      BinusianID: binusianID,
    })
  );

  return dataAPI.data.data;
};
